<template>
  <div v-if="routerData" class="layout-sider">
    <el-menu
      :default-active="fullPath"
      unique-opened
      text-color="#000"
      active-text-color="#1890ff"
      @select="selectMenu"
    >
      <menu-item :data="routerData" :path="routerData.path"></menu-item>
    </el-menu>
  </div>
</template>

<script>
import menus from '@/utils/menus.js'
import MenuItem from './menu-item/menu-item.vue'

export default {
  name: 'sider',
  components: {
    MenuItem,
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    routerData() {
      const data = menus().find(item => item.name === this.$route.matched[0].name)

      return data
    },

    fullPath() {
      return this.$route.fullPath
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleMenu(path) {
      console.log(path)
      if (this.$route.path === path) return
      this.$router.push(path)
    },

    selectMenu(index, indexPath) {
      console.log(index)
      if (this.fullPath === index) return

      this.$router.push(index)
    },
  },
}
</script>

<style scoped lang="less">
.layout-sider {
  flex-shrink: 0;
  width: 180px;
  height: 100%;
  overflow: auto;
  ::v-deep .el-menu {
    width: 100%;
    min-height: 100%;
    border: none;
    .menu-wrap {
      width: 100%;
      .menu-item {
        width: 100%;
        .el-submenu {
          .el-submenu__title {
            &:hover {
              background-color: transparent;
            }
          }
        }
        .el-menu-item {
          &.is-active {
            background-color: #a1c4fd33;
          }
          &:hover {
            background-color: #a1c4fd33;
          }
        }
      }
    }
  }
}
</style>
